export const fr = {
  common: {
    yes: 'Oui',
    no: 'Non',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    open: 'Ouvrir',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    loading: 'Chargement…',
    saving: 'Enregistrement…',
    sending: 'Envoi…',
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tous',
    none: 'Aucun',
    add: 'Ajouter',
    remove: 'Retirer',
    yes_remove: 'Oui, supprimer',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Info',
    welcome: 'Bienvenue',
    logout: 'Déconnexion',
    settings: 'Paramètres',
    language: 'Langue',
    fcfa_short: 'FCFA',
    optional: 'optionnel',
    required: 'requis',
    submit: 'Envoyer',
    create: 'Créer',
    update: 'Mettre à jour',
    refresh: 'Actualiser',
    retry: 'Réessayer',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    tomorrow: 'Demain',
    date: 'Date',
    time: 'Heure',
    amount: 'Montant',
    quantity: 'Quantité',
    name: 'Nom',
    email: 'Email',
    password: 'Mot de passe',
    phone: 'Téléphone',
    address: 'Adresse',
    notes: 'Notes',
    description: 'Description',
    status: 'Statut',
    actions: 'Actions',
    details: 'Détails',
    history: 'Historique',
    not_authenticated: 'Non authentifié',
    forbidden: 'Accès refusé',
    not_found: 'Introuvable',
    network_error: 'Erreur réseau',
    please_try_again: 'Veuillez réessayer',
    created: 'Créé',
    updated: 'Mis à jour',
    deleted: 'Supprimé',
    validated: 'Validé',
    cancelled: 'Annulé',
    sent: 'Envoyé',
    received: 'Reçu',
    refunded: 'Remboursé',
    coming_soon: 'Bientôt disponible',
    no_results: 'Aucun résultat',
    empty_list: 'Liste vide',
    or: 'ou',
    and: 'et',
    of: 'de',
    on: 'sur',
    by: 'par',
    from: 'de',
    to: 'à',
    at: 'à',
  },
  nav: {
    dashboard: 'Tableau de bord',
    assistant_ai: '🤖 Assistant IA',
    inbox: 'Inbox',
    stocks: 'Stocks',
    inventory: 'Inventaire',
    batches: 'Lots',
    cashier: 'Caisse',
    cash_closure: 'Clôture caisse',
    customer_credits: 'Crédits clients',
    deliveries: 'Livraisons',
    insurance_claims: 'Tiers payant',
    prescriptions: 'Ordonnances',
    proforma: 'Devis',
    payments: 'Paiements',
    accounting: 'Comptabilité',
    tva: 'TVA',
    notifications: 'Notifications',
    loyalty: 'Fidélité',
    rewards: 'Récompenses',
    analytics: 'Analytics',
    anomalies: '⚠️ Anomalies',
    ratings: '⭐ Notation',
    hr: 'RH',
    sms_campaigns: '📱 Campagnes SMS',
    cashiers: 'Caissiers',
    suppliers: 'Fournisseurs',
    purchase_orders: 'Bons de commande',
    auto_replenish: 'Réappro auto',
    backups: 'Sauvegardes',
    audit: 'Audit',
    formation: 'Formation',
    settings: 'Paramètres',
    home: 'Accueil',
    carnet: 'Carnet',
    find: 'Trouver',
    orders: 'Commandes',
    points: 'Points',
    profile: 'Profil',
    navigation: 'Navigation',
    earnings: 'Revenus',
  },
  login: {
    title: 'Connexion',
    subtitle: 'Accédez à votre tableau de bord PharmaConnect',
    email_label: 'Email',
    email_placeholder: 'votre@email.cm',
    password_label: 'Mot de passe',
    password_placeholder: '••••••••',
    submit: 'Se connecter',
    forgot_password: 'Mot de passe oublié ?',
    invalid_credentials: 'Email ou mot de passe incorrect',
    or_pin: 'Caissier ? Connexion par PIN',
    pharmacist_tab: 'Pharmacien',
    cashier_tab: 'Caissier',
    signup_tab: 'Inscription',
    full_name: 'Nom complet',
    referral_code: 'Code parrainage (facultatif)',
    referral_hint: '🎁 Vous gagnerez 50 points dès votre 1er achat (et votre parrain aussi).',
    create_account: 'Créer mon compte',
    space_patient: 'Espace patient',
    space_driver: 'Espace livreur',
    space_driver_hint:
      'Compte créé par votre administrateur PharmaConnect après validation CNI.',
    driver_become: 'Pas encore de compte livreur ? Devenir livreur',
    switch_patient: 'Vous êtes patient ? Connexion ici',
    switch_driver: 'Vous êtes livreur ? Connexion ici',
    validation_failed: 'Email valide et mot de passe ≥ 8 caractères requis',
  },
  forgot: {
    title: 'Mot de passe oublié',
    subtitle: 'Saisis ton email pour recevoir un lien de réinitialisation.',
    send_link: 'Envoyer le lien',
    sent_title: 'Email envoyé',
    sent_message:
      'Si un compte existe avec {email}, un email contenant un lien de réinitialisation vient d’être envoyé. Vérifie ta boîte (et les spams).',
    sent_hint:
      'Le lien expire dans 1 heure. Ouvre-le sur n’importe quel navigateur, définis ton nouveau mot de passe, puis reviens te connecter ici.',
    back_to_login: '← Retour à la connexion',
  },
  reset: {
    title: 'Nouveau mot de passe',
    subtitle: 'Choisissez un nouveau mot de passe sécurisé.',
    new_password: 'Nouveau mot de passe',
    confirm_password: 'Confirmer le mot de passe',
    submit: 'Mettre à jour',
    checking: 'Vérification du lien de réinitialisation…',
    link_invalid:
      'Si vous voyez ce message plus de quelques secondes, le lien est invalide ou expiré (max 1h après envoi).',
    request_new_link: 'Demander un nouveau lien',
    too_short: 'Mot de passe trop court (8 caractères minimum)',
    mismatch: 'Les deux mots de passe ne correspondent pas',
    success: 'Mot de passe mis à jour',
  },
  dashboard: {
    title: 'Tableau de bord',
    today_revenue: 'CA du jour',
    today_sales: 'Ventes du jour',
    low_stock: 'Stock bas',
    imminent_stockouts: 'Ruptures sous 7j',
    deliveries_active: 'Livraisons en cours',
    overdue_credits: 'Impayés en retard',
    pending_accounting: 'Écritures à valider',
    insurance_pending: 'Tiers payant à traiter',
    customize_button: '⚙ Personnaliser',
    customize_title: 'Personnaliser le tableau de bord',
    customize_description:
      'Choisissez quelles cards afficher. Vos préférences sont synchronisées sur tous vos appareils.',
    customize_tip:
      'Tip : masquer une card ne supprime pas les données — réactivez-la quand vous voulez.',
    no_pharmacy: 'Aucune pharmacie associée à votre compte.',
  },
  user_role: {
    owner: 'Propriétaire',
    manager: 'Gérant',
    cashier: 'Caissier',
    super_admin: 'Super admin',
    patient: 'Patient',
    driver: 'Livreur',
    doctor: 'Médecin',
  },
  home: {
    hello: 'Bonjour',
    qr_urgence: 'QR urgence',
    notifications: 'Notifications',
    pharmacy_nearest: 'Pharmacie la plus proche',
    on_call_pharmacies: 'Pharmacies de garde',
    quick_actions: 'Actions rapides',
    reminders_today: "Rappels d’aujourd’hui",
    no_reminders: 'Aucun rappel pour aujourd’hui — bravo !',
    recent_vitals: 'Constantes récentes',
    loyalty_balance: 'Points fidélité',
    points: 'pts',
    your_orders: 'Vos commandes',
    no_orders: 'Aucune commande en cours.',
    take_pill: 'Prendre',
    pill_taken: 'Pris',
  },
  carnet: {
    title: 'Carnet de santé',
    vitals: 'Constantes vitales',
    add_vital: 'Ajouter une constante',
    reminders: 'Rappels de médicaments',
    add_reminder: 'Ajouter un rappel',
    no_vitals: 'Aucune constante enregistrée.',
    no_reminders: 'Aucun rappel actif.',
    blood_pressure: 'Tension',
    glucose: 'Glycémie',
    weight: 'Poids',
    temperature: 'Température',
    measured_at: 'Mesuré le',
    medication_name: 'Nom du médicament',
    dosage: 'Posologie',
    times: 'Heures',
    frequency: 'Fréquence',
    daily: 'Quotidien',
    twice_daily: 'Deux fois par jour',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
  },
  profile: {
    title: 'Profil',
    edit: 'Modifier mon profil',
    blood_group: 'Groupe sanguin',
    weight_kg: 'Poids (kg)',
    height_cm: 'Taille (cm)',
    allergies: 'Allergies',
    chronic_diseases: 'Maladies chroniques',
    emergency_contacts: "Contacts d'urgence",
    qr_emergency: "QR d'urgence",
    qr_share_hint:
      'Présentez ce QR à un soignant en cas d’urgence — il accède aux infos vitales sans connexion internet.',
    saved: 'Modifications enregistrées',
    save_failed: 'Sauvegarde impossible',
    open_inbox: '📥 Notifications',
    open_documents: '📁 Mes documents',
    open_family: '👨‍👩‍👧 Mode famille',
    open_consents: '🔐 Consentements médecins',
    open_assurances: '🛡 Mes assurances',
    open_quiz: '🎓 Formation santé',
    open_appointments: '📅 Mes RDV',
    open_vaccinations: '💉 Vaccinations',
    open_pharmacovigilance: '⚠ Signaler effet secondaire',
    open_grossesse: '🤰 Suivi de grossesse',
    open_regles: '🌸 Suivi des règles',
    open_depistage: '🎗 Dépistage cancer',
    open_sante_mentale: '🧠 Santé mentale',
    open_nutrition: '🥗 Plan nutrition',
    open_activite: '🏃 Activité physique',
    open_dons_sang: '🩸 Dons de sang',
    open_carte_donneur: '🆔 Carte donneur',
    export_pdf: '📄 Exporter mon dossier PDF',
  },
  cashier: {
    title: 'Caisse',
    cart: 'Panier',
    empty_cart: 'Le panier est vide.',
    add_medication: 'Ajouter un médicament',
    customer: 'Client',
    anonymous: 'Anonyme',
    select_patient: 'Sélectionner un patient',
    total: 'Total',
    subtotal: 'Sous-total',
    discount: 'Remise',
    insurance: 'Assurance',
    coverage: 'Couverture',
    payment_method: 'Mode de paiement',
    cash: 'Espèces',
    mtn_momo: 'MTN MoMo',
    orange_money: 'Orange Money',
    camerpay: 'CamerPay',
    card: 'Carte',
    pay: 'Encaisser',
    receipt: 'Reçu',
    print_receipt: 'Imprimer le reçu',
    send_receipt: 'Envoyer le reçu',
    sale_complete: 'Vente enregistrée',
    insufficient_stock: 'Stock insuffisant',
  },
  medications: {
    title: 'Médicaments',
    add: 'Ajouter un médicament',
    name: 'Nom',
    dci: 'DCI',
    form: 'Forme',
    dosage: 'Dosage',
    barcode: 'Code-barres',
    price: 'Prix',
    quantity: 'Quantité',
    alert_threshold: 'Seuil d’alerte',
    expiry: 'Péremption',
    supplier: 'Fournisseur',
    category: 'Catégorie',
    in_stock: 'En stock',
    out_of_stock: 'Rupture',
    low_stock: 'Stock bas',
    expires_soon: 'Expire bientôt',
    expired: 'Périmé',
  },
  accounting: {
    title: 'Comptabilité',
    journal: 'Journal',
    new_entry: 'Nouvelle écriture',
    income: 'Recette',
    expense: 'Dépense',
    pending: 'En attente',
    validated: 'Validé',
    label: 'Libellé',
    category: 'Catégorie',
    reference: 'Référence',
    total_income: 'Total recettes',
    total_expense: 'Total dépenses',
    net_result: 'Résultat net',
    export_pdf: 'Export PDF',
    export_csv: 'Export CSV',
    validate: 'Valider',
    cant_modify_validated: 'Impossible de modifier une écriture validée',
  },
  deliveries: {
    title: 'Livraisons',
    pending: 'En attente',
    paid: 'Payée',
    assigned: 'Assignée',
    in_transit: 'En cours',
    delivered: 'Livrée',
    cancelled: 'Annulée',
    track_driver: 'Suivre le livreur',
    confirm_delivery: 'Confirmer la livraison',
    scan_driver_qr: 'Scanner le QR du livreur',
    driver_eta: 'ETA',
    delivery_address: 'Adresse de livraison',
    delivery_fee: 'Frais de livraison',
    rate_driver: 'Noter le livreur',
  },
  prescriptions: {
    title: 'Ordonnances',
    active: 'Active',
    dispensed: 'Délivrée',
    expired: 'Expirée',
    prescribed_by: 'Prescrit par',
    prescribed_on: 'Le',
    medications: 'Médicaments',
    duration: 'Durée',
    signed_digital: 'Signature numérique',
    verify: 'Vérifier la signature',
    upload_image: 'Photo ordonnance',
    request_quote: 'Demander un devis',
  },
  loyalty: {
    title: 'Fidélité',
    balance: 'Solde',
    tier: 'Niveau',
    bronze: 'Bronze',
    silver: 'Argent',
    gold: 'Or',
    platinum: 'Platine',
    earned_total: 'Gagnés au total',
    spent_total: 'Dépensés au total',
    next_tier_at: 'Niveau suivant à',
    history: 'Historique',
    earn_action: 'Gagné',
    spend_action: 'Dépensé',
    bonus_action: 'Bonus',
    expire_action: 'Expiré',
    rewards_catalog: 'Catalogue récompenses',
    redeem: 'Échanger',
    insufficient_points: 'Points insuffisants',
  },
  insurance: {
    title: 'Mes assurances',
    add: '+ Ajouter une assurance',
    provider: 'Assureur',
    policy_number: 'N° de police',
    coverage_rate: 'Taux de couverture (%)',
    is_primary: 'Assurance principale',
    no_insurance: 'Aucune assurance déclarée. Touchez + pour en ajouter une.',
    declare_at_caisse:
      'Déclarez vos assurances santé pour que la pharmacie puisse appliquer le tiers payant automatiquement à votre caisse.',
    not_in_list: "Mon assurance n'est pas dans la liste",
    custom_name: 'Nom de votre assureur',
    saved: 'Assurance enregistrée',
    auto_applied: 'Elle sera automatiquement proposée à la caisse.',
  },
  family: {
    title: 'Mode famille',
    why: 'Pourquoi ?',
    why_text:
      'Ajoute les membres de ta famille (enfants, parents âgés…) pour gérer leurs constantes vitales, rappels de médicaments et carnet de vaccination depuis ton propre compte.',
    add_member: 'Ajouter un membre',
    members: 'Membres enregistrés',
    no_members: 'Personne pour le moment.',
    full_name: 'Nom complet',
    date_of_birth: 'Date de naissance',
    blood_group: 'Groupe sanguin',
    bootstrap_vaccines: '💉 Générer rappels vaccinaux',
    open_growth: '📏 Croissance & développement',
    add_dob_first: 'Ajoutez la date de naissance pour activer les rappels vaccinaux PEV.',
  },
  pregnancy: {
    title: '🤰 Suivi de grossesse',
    start_button: '🤰 Créer mon carnet',
    intro:
      "Carnet de grossesse numérique avec calendrier OMS — 16 RDV planifiés automatiquement à partir de la date des dernières règles (DDR).",
    lmp_date: 'Date des dernières règles (YYYY-MM-DD) *',
    gravida: 'Gravidité (nb grossesses)',
    parity: 'Parité (nb accouchements)',
    partner_phone: 'Tél du conjoint / urgence',
    upcoming: 'RDV à venir',
    done: 'RDV effectués',
    mark_done: '✓ Fait',
    next_rdv: '🔔 Prochain RDV',
    close: 'Clôturer le suivi',
    close_choose: 'Quel est le résultat ?',
    close_delivered: 'Accouchement',
    close_lost: 'Perte',
    close_archived: 'Le carnet de grossesse est archivé.',
  },
  regles: {
    title: '🌸 Suivi des règles',
    intro:
      'Carnet de cycles menstruels. Tes données sont 100% privées — visibles uniquement par toi.',
    started_today: '🩸 Mes règles ont commencé aujourd’hui',
    ended_today: '✓ Mes règles sont terminées',
    flow_intensity: 'Intensité du flux',
    flow_light: 'Léger',
    flow_medium: 'Moyen',
    flow_heavy: 'Abondant',
    flow_very_heavy: 'Très abondant',
    next_period: 'Prochaines règles',
    ovulation: 'Ovulation estimée',
    fertile_window: 'Fenêtre fertile',
    statistics: '📊 Statistiques',
    cycles_logged: 'cycles enregistrés',
    avg_cycle: 'cycle moyen',
    avg_duration: 'durée règles',
    regularity: 'régularité',
    history: '📅 Historique',
    no_cycles: 'Aucun cycle enregistré.',
    phase_menstruation: '🩸 Menstruation',
    phase_follicular: '🌱 Folliculaire',
    phase_ovulation: '💜 Ovulation',
    phase_luteal: '🌙 Lutéale',
  },
  depistage: {
    title: '🎗 Dépistage du cancer',
    intro:
      "Module d'aide au suivi des dépistages préventifs (mammographie, frottis, palpation, test HPV). Recommandations OMS.",
    dob_required: '📅 Date de naissance requise',
    dob_hint:
      "Pour calculer ton éligibilité aux dépistages, l'app a besoin de ta date de naissance.",
    mammogram: 'Mammographie',
    pap_smear: 'Frottis (col utérin)',
    breast_exam: 'Palpation des seins',
    hpv_test: 'Test HPV',
    last: 'Dernier',
    next: 'Prochain',
    log_done: "+ J'ai effectué ce dépistage",
    result_normal: 'Normal',
    result_abnormal: 'Anormal',
    result_inconclusive: 'Non concluant',
    result_pending: 'En attente',
    status_unknown_age: 'Renseigne ta date de naissance',
    status_too_young: 'Pas encore concerné',
    status_past_age_range: 'Plus dans la tranche d’âge',
    status_never_done: 'À planifier',
    status_overdue: 'En retard',
    status_due_soon: 'À faire bientôt',
    status_on_time: 'À jour',
    saved: 'Dépistage enregistré.',
  },
  mental_health: {
    title: '🧠 Santé mentale',
    intro:
      "Outils d'auto-évaluation validés (PHQ-9, GAD-7) et journal d'humeur. Tes données sont 100% privées — visibles uniquement par toi.",
    tab_summary: 'Synthèse',
    tab_assessment: 'Auto-éval',
    tab_mood: 'Humeur',
    phq9: 'PHQ-9 (dépression)',
    gad7: 'GAD-7 (anxiété)',
    not_yet: 'Pas encore',
    mood_label: 'Humeur',
    energy_label: 'Énergie',
    anxiety_label: 'Anxiété',
    save_mood: '+ Enregistrer',
    saved: 'Humeur enregistrée pour aujourd’hui.',
    severity_minimal: 'Minimal',
    severity_mild: 'Léger',
    severity_moderate: 'Modéré',
    severity_moderately_severe: 'Modéré-sévère',
    severity_severe: 'Sévère',
    red_flag_title: '⚠ Aide immédiate',
    red_flag_message:
      'Tes réponses suggèrent un besoin d’aide urgente. Appelle le 119 (SAMU Cameroun) ou rends-toi aux urgences. Tu n’es pas seul·e.',
    call_119: 'Appeler 119',
    resources: '📚 Ressources d’aide',
  },
  nutrition: {
    title: '🥗 Plan nutrition',
    intro: 'Recommandations personnalisées selon ton IMC, ton objectif et ton profil santé.',
    bmi: 'IMC',
    bmi_underweight: 'Insuffisance pondérale',
    bmi_normal: 'Normal',
    bmi_overweight: 'Surpoids',
    bmi_obese_1: 'Obésité I',
    bmi_obese_2: 'Obésité II',
    bmi_obese_3: 'Obésité III',
    goal_lose: 'Perdre du poids',
    goal_maintain: 'Maintenir mon poids',
    goal_gain: 'Prendre du poids',
    goal_pregnancy: 'Soutenir ma grossesse',
    goal_breastfeed: 'Soutenir mon allaitement',
    activity_sedentary: 'Sédentaire',
    activity_light: 'Léger (1-2x/sem)',
    activity_moderate: 'Modéré (3-4x/sem)',
    activity_active: 'Actif (5x/sem)',
    activity_very_active: 'Très actif (quotidien)',
    local_foods: '🍽 Aliments locaux',
    info_disclaimer:
      'Ces recommandations sont à titre informatif. Pour un programme nutritionnel précis, consulte un médecin nutritionniste ou un diététicien.',
  },
  activite: {
    title: '🏃 Activité du jour',
    intro: 'Bouge au moins 30 min ou fais 7000 pas par jour. +5 points fidélité par jour actif !',
    steps: 'Pas',
    minutes: 'Minutes exercice',
    goal_reached: '✅ Objectif atteint aujourd’hui',
    current_streak: 'Streak actuel',
    best_streak: 'Meilleur streak',
    days_active_week: 'Jours actifs (sem.)',
    days_active_month: 'Jours actifs (mois)',
    save_today: '+ Enregistrer',
    bonus_credited: 'Journée active enregistrée. +5 points fidélité ajoutés à ton compte.',
  },
  driver: {
    title: 'Espace livreur',
    earnings: 'Revenus',
    rating: 'Note',
    deliveries_today: 'Livraisons aujourd’hui',
    deliveries_total: 'Total livraisons',
    active_order: 'Commande active',
    no_active_order: 'Aucune commande active.',
    no_orders: 'Aucune commande pour le moment.',
    accept: 'Accepter',
    start_delivery: 'Démarrer la livraison',
    mark_arrived: 'Arrivé chez le patient',
    take_photo: 'Prendre photo CNI',
    show_badge: 'Montrer mon badge QR',
    badge_subtitle: 'À présenter au patient pour confirmer la livraison',
    certified: 'Certifié',
    not_certified: 'Non certifié',
    cni_pending: 'CNI en cours de validation',
    open_navigation: 'Ouvrir dans Google Maps',
    distance_to_patient: 'Distance au patient',
    earnings_today: 'Revenu du jour',
    earnings_week: 'Cette semaine',
    earnings_month: 'Ce mois',
    last_payouts: 'Derniers virements',
    no_payouts: 'Aucun virement.',
    bank_account: 'Compte de paiement',
    update_bank: 'Modifier mes coordonnées',
  },
  orders: {
    title: 'Mes commandes',
    no_orders: 'Aucune commande pour le moment.',
    placed_on: 'Passée le',
    items: 'articles',
    total: 'Total',
    track: 'Suivre',
    details: 'Détails',
    cancel: 'Annuler la commande',
    confirm_received: 'Confirmer la réception',
    status_pending: 'En attente',
    status_paid: 'Payée',
    status_assigned: 'Assignée',
    status_in_transit: 'En cours',
    status_delivered: 'Livrée',
    status_cancelled: 'Annulée',
  },
}

// Type récursif qui remplace toutes les valeurs littérales par `string`
// (sinon FrenchDict force les autres langues à utiliser exactement les
// chaînes françaises, ce qui défait l'i18n)
type RecursiveString<T> = {
  [K in keyof T]: T[K] extends Record<string, unknown> ? RecursiveString<T[K]> : string
}

export type FrenchDict = RecursiveString<typeof fr>
